module.exports = {"UM_DOMAIN":"testcontest.heymath.com/um","REV_DOMAIN":"testplprevision.heymath.com","PC_DOMAIN":"testplppc.heymath.com","WEB_DOMAIN":"testplp.heymath.com","OPS_DOMAIN":"testops.heymath.com","LUMOS_PC_DOMAIN":"testpc.heymath.com","LUMOS_UM_DOMAIN":"testlumos.heymath.com","WIRIS_DOMAIN":"testme.heymath.com","CS_DOMAIN":"testcs.heymath.com","CP_DOMAIN":"testcontest.heymath.com","CONTEST_UM_DOMAIN":"testcontest.heymath.com/um","CP_DOMAIN_API":"testcontest.heymath.com/api"}


//////////////////
// WEBPACK FOOTER
// ./src/config/urls.json
// module id = 153
// module chunks = 0